import { DashboardShell } from "./DashboardShell";
import { SettingsProvider } from "@/modules/settings";
import { NotificationProvider } from "@/modules/notifications";
import { SearchProvider } from "@/modules/search";
import { ToastProvider } from "@/shared/providers/ToastProvider";

type AppPageLayoutProps = {
  children: React.ReactNode;
};

export function AppPageLayout({ children }: AppPageLayoutProps) {
  return (
    <ToastProvider>
      <NotificationProvider>
        <SearchProvider>
          <SettingsProvider>
            <DashboardShell>{children}</DashboardShell>
          </SettingsProvider>
        </SearchProvider>
      </NotificationProvider>
    </ToastProvider>
  );
}
